// @owners { team: patients }
import { SIZES } from '@alto/design-library-tokens';
import { Column, H1, Row } from '@alto/design-system';
import React from 'react';
import { Platform } from 'react-native';
import styled from 'styled-components/native';
import { getProgynyPageBackgroundColor } from '../../shared/components/progynyBackgroundColor';

const Background = styled(Column)`
  ${Platform.OS === 'web' ? `min-height: calc(100vh - ${SIZES.PAGE.WEB_FOOTER_HEIGHT.LG});` : ''}
`;

export const CalculatingQuantities = () => {
  return (
    <Background
      flexGrow={1}
      flexShrink={1}
      backgroundColor={getProgynyPageBackgroundColor()}
    >
      <Row
        center
        flexGrow={1}
      >
        <Column center>
          <H1 center>Thanks! Now calculating your order...</H1>
        </Column>
      </Row>
    </Background>
  );
};
